import React, { Component } from 'react';
import { authHeader, authHeaderJson } from '../auth-header';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import CancelIcon from '@material-ui/icons/CancelOutlined';
import IconRefresh from '@material-ui/icons/Refresh';
import IconFirstPage from '@material-ui/icons/FirstPage';
import IconPrev from '@material-ui/icons/NavigateBefore';
import IconNext from '@material-ui/icons/NavigateNext';
import IconLastPage from '@material-ui/icons/LastPage';
import IconPrio from '@material-ui/icons/PriorityHigh';
import IconPlus from '@material-ui/icons/Add';
import IconDelete from '@material-ui/icons/DeleteForever';
import IconSave from '@material-ui/icons/Save';

import IconFile from '@material-ui/icons/Attachment';
import IconOK from '@material-ui/icons/CheckCircleOutline';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { IconButton, Dialog, Button, CircularProgress, AppBar, Typography, Toolbar, TextField, DialogContentText } from '@material-ui/core'

import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
registerPlugin(FilePondPluginFileValidateType);



const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit,
    },
    err: {
        color: theme.palette.error.main,
    },
    grow: {
        flexGrow: 1,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '100%',
    },
});


class DbModifRequest extends Component {
    static displayName = DbModifRequest.name;
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            loading: true,
            dialogOpen: false,
            notDataId: 0,
            search: '',
            currentPage: 1,
            pageCount: 0,
            result: null,
            fpServer: null,
            txt: '',
            fileId: -1,
            fileCnt: 0,
            openDel: false,
            delText: '',
            delId: 0,
        };
        this.handleClose = this.handleClose.bind(this);
    };


    componentDidMount() {
        this.loadNots();
    }

    getDateTime(datstr) {
        if (datstr === null) return '';
        var dat = new Date(datstr);
        var yyyy = dat.getFullYear();
        var mm = dat.getMonth() < 9 ? "0" + (dat.getMonth() + 1) : (dat.getMonth() + 1); // getMonth() is zero-based
        var dd = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
        var hh = dat.getHours() < 10 ? "0" + dat.getHours() : dat.getHours();
        var min = dat.getMinutes() < 10 ? "0" + dat.getMinutes() : dat.getMinutes();
        var ss = dat.getSeconds() < 10 ? "0" + dat.getSeconds() : dat.getSeconds();
        return "" + dd + "." + mm + "." + yyyy + " " + hh + ":" + min + ":" + ss;
    };

    loadNots() {
        this.setState({ loading: true });

        fetch('api/ModifyReproDb/List', {
            headers: authHeaderJson(),
            body: JSON.stringify({ page: this.state.currentPage, search: this.state.search, rows: 30 }),
            method: 'post'
        })
            .then(response => response.json())
            .then(data => {
                //           console.log(data);
                this.setState({
                    listData: data.results,
                    pageCount: data.pageCount,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({ loading: false });
            });
    }
    firstPage() {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: 1 }, () => this.loadNots());
        }
    }
    prevPage() {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 }, () => this.loadNots());
        }
    }
    nextPage() {
        var curr = this.state.currentPage;
        if (curr < this.state.pageCount) {
            this.setState({ currentPage: curr + 1 }, () => this.loadNots());
        }
    }
    lastPage() {
        var curr = this.state.currentPage;
        if (curr < this.state.pageCount) {
            this.setState({ currentPage: this.state.pageCount }, () => this.loadNots());
        }
    }
    validate(file, type) {
        return new Promise((resolve, reject) => {
            let ext = file.name.split('.').pop().toLowerCase()
            if (ext === "sql") {
                resolve('application/sql')
            } else {
                reject('Neplatný typ súboru');
            }
        })
    }

    show(event, id) {
        fetch('api/ModifyReproDb/' + id, { headers: authHeader() })
            .then(res => res.blob())
            .then(data => {
                //          console.log(data);
                this.downloadData('wrepro.sql', data);
            })
            .catch(err => { console.error(err); })
    }
    downloadData(filenameForDownload, data) {
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(data, filenameForDownload);
        }
        else {
            var textUrl = URL.createObjectURL(data);
            var element = document.createElement('a');
            element.setAttribute('href', textUrl);
            element.setAttribute('download', filenameForDownload);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);
        }
    }

    handleClose() {
        this.setState({ dialogOpen: false, fileId: -1 });
    }

    render() {
        const { classes } = this.props;
        const { fullScreen } = this.props;
        const table = (
            <Table padding="none">
                <TableHead>
                    <TableRow>
                        <TableCell padding="dense">Deň</TableCell>
                        <TableCell>Stav</TableCell>
                        <TableCell>Vybavil</TableCell>
                        <TableCell>Súbor</TableCell>
                        <TableCell></TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.listData.map(not =>
                        <TableRow key={not.id} hover>
                            <TableCell padding='dense' >{this.getDateTime(not.requestTime)}</TableCell>
                            <TableCell>{not.fileSize > 0 ? <IconOK /> : <IconPrio />}</TableCell>
                            <TableCell>{not.exportUser}</TableCell>
                            <TableCell>{not.fileSize > 0 && (not.fileSize / 1048576).toFixed(1) + ' MB'} </TableCell>
                            <TableCell>{not.fileSize > 0 &&
                                <IconButton onClick={event => this.show(event, not.id)}><IconFile /></IconButton >
                            }
                                <IconButton onClick={event => this.delRow(event, not.id, this.getDateTime(not.requestTime))}><IconDelete /></IconButton >
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        );

        return (
            <div className={classes.root} >
                <AppBar position="static">
                    <Toolbar>
                        <Typography className={classes.grow} variant="h6" color="inherit">Prehľad žiadostí</Typography>
                        <IconButton color="inherit" onClick={(e) => this.setState({ dialogOpen: true })} >
                            <IconPlus />
                        </IconButton>
                        <IconButton color="inherit" onClick={this.loadNots.bind(this)}>
                            <IconRefresh />
                        </IconButton>

                        <IconButton color="inherit" disabled={this.state.currentPage <= 1} onClick={this.firstPage.bind(this)}>
                            <IconFirstPage fontSize="small" />
                        </IconButton>
                        <IconButton color="inherit" disabled={this.state.currentPage <= 1} onClick={this.prevPage.bind(this)}>
                            <IconPrev fontSize="small" />
                        </IconButton>
                        <Typography variant="body1" color="inherit">{this.state.currentPage}/{this.state.pageCount}</Typography>

                        <IconButton color="inherit" disabled={this.state.currentPage === this.state.pageCount} onClick={this.nextPage.bind(this)}>
                            <IconNext fontSize="small" />
                        </IconButton>
                        <IconButton color="inherit" disabled={this.state.currentPage === this.state.pageCount} onClick={this.lastPage.bind(this)}>
                            <IconLastPage fontSize="small" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Paper>
                    {this.state.loading ? <CircularProgress /> : table}
                </Paper>

                <Dialog
                    fullWidth={true}
                    maxWidth="md"
                    fullScreen={fullScreen}
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title">
                    <DialogTitle id="responsive-dialog-title">Nová žiadosť</DialogTitle>
                    <DialogContent>
                        <Typography component="div" variant="subtitle2" className={classes.textField}>Zadajte požadovanú upravu - zoznam chovov pre doplnenie</Typography>
                        <TextField
                            disabled={this.state.fileId > 0}
                            id="standard-multiline-static"
                            multiline variant="outlined"
                            rows="6"
                            value={this.state.txt}
                            onChange={this.handleChange('txt')}
                            className={classes.textField}
                            margin="normal"
                        />
                        <FilePond ref={ref => this.pond = ref}
                            className={classes.pond}
                            allowMultiple={false}
                            allowRevert={false}
                            acceptedFileTypes="application/sql,.sql"
                            fileValidateTypeDetectType={this.validate}
                            labelIdle='Podporované sú iba SQL súbory exportu <strong>WReproHD</strong><br/><br/>Presuňte súbor sem alebo<span class=" filepond--label-action"> Vyberte súbor </span>'
                            labelFileProcessingComplete='Súbor úspešne nahraný na sever'
                            labelFileProcessing="Prebieha nahrávanie"
                            labelTapToCancel="Prerušiť"
                            labelInvalidField="Neplatný typ súboru"
                            labelFileTypeNotAllowed='Neplatný typ súboru'
                            fileValidateTypeLabelExpectedTypes='Očakávaný formát .sql (wreprohd)'
                            labelFileProcessingError='Nastala chyba pri nahrávaní na server'
                            labelTapToRetry='Kliknite sem pre opakovanie'
                            onerror={(err, file, stat) => {
                                console.log('Error on filepond');
                                console.log(err);
                            }}
                            instantUpload={false}
                            onupdatefiles={fileItems => { this.setState({ fileCnt: fileItems.length }); }}
                            server=
                            {
                                {
                                    url: 'api/ModifyReproDb',
                                    process: {
                                        headers: authHeader(),
                                        onload: (resp) => {
                                            this.handleClose();
                                            this.loadNots();
                                        },
                                        ondata: (formData) => {
                                            formData.append('reqid', this.state.fileId);
                                            return formData;
                                        }
                                    },
                                    fetch: null,
                                    revert: null,
                                }
                            }
                        />
                        {this.state.fileId > 0 &&
                            <Typography component="div" variant="subtitle2" className={classes.textField}>Počkajte prosím, kým prebehne nahrávanie súboru. Tento dialóg sa automaticky zavrie.</Typography>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            disabled={this.state.fileCnt !== 1 || this.state.txt.length === 0 || this.state.fileId > 0}
                            onClick={e => this.upload()} color="secondary" variant="outlined"><IconSave />Odoslať</Button>
                        <Button onClick={e => this.handleClose()} color="secondary" variant="outlined"><CancelIcon />Zrušiť</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openDel}
                    onClose={(e) => this.setState({ openDel: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Naozaj vymazať?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">Naozaj si prajete vymazať žiadosť zo dňa {this.state.delText} ?</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={e => this.delRowConf()} color="secondary">Vymazať</Button>
                        <Button onClick={(e) => this.setState({ openDel: false })} color="secondary" autoFocus>Ponechať</Button>
                    </DialogActions>
                </Dialog>

            </div >
        );
    }
    delRow(event, id, reqDate) {
        this.setState({
            delText: reqDate,
            openDel: true,
            delId: id
        });
    }
    delRowConf() {
        var id = this.state.delId;
        fetch('api/ModifyReproDb/' + id, { headers: authHeaderJson(), method: 'delete' })
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        openDel: false
                    }, () => this.loadNots());
                }
            })
            .catch(err => { console.error(err); })
    }
    upload() {
        fetch('api/ModifyReproDb/AddRequest', {
            headers: authHeaderJson(),
            method: 'post',
            body: JSON.stringify({ txt: this.state.txt })
        })
            .then(response => response.json())
            .then(data2 => {
                if (data2.ok === true) {
                    this.setState({ fileId: data2.id }, () => this.pond.processFiles());
                }

            })
            .catch(err => { });
    }
    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };
}
DbModifRequest.propTypes = {
    classes: PropTypes.object.isRequired,
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(withStyles(styles)(DbModifRequest));


// WEBPACK FOOTER //
// ./src/components/insem/DBRequest.jsx